import {
  GET_PAYMENT_METHODS_REQUEST,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_FAILURE,
  SHOW_PAYMENT_METHOD_FORM,
  HIDE_PAYMENT_METHOD_FORM,
  CREATE_PAYMENT_METHOD_REQUEST,
  CREATE_PAYMENT_METHOD_SUCCESS,
  CREATE_PAYMENT_METHOD_FAILURE,
  SET_DEFAULT_PAYMENT_METHOD_REQUEST,
  SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
  SET_DEFAULT_PAYMENT_METHOD_FAILURE,
  SHOW_CONFIRM_DELETE_PAYMENT_METHOD,
  HIDE_CONFIRM_DELETE_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD_REQUEST,
  DELETE_PAYMENT_METHOD_SUCCESS,
  DELETE_PAYMENT_METHOD_FAILURE,
} from './paymentMethodsTypes';
import api from '../../api';
import {createAlert} from '../Alert/alertActions';
import isValidCreditCard from '../../utils/isValidCreditCard';
import {shouldValidatePostalCode, shouldValidateAddress} from './utils';

export function getPaymentMethods() {
  return function(dispatch) {
    dispatch({type: GET_PAYMENT_METHODS_REQUEST});
    return api.get(`/payment-methods`).then(
      response => {
        dispatch({type: GET_PAYMENT_METHODS_SUCCESS, response: response.data});
      },
      error => {
        dispatch({type: GET_PAYMENT_METHODS_FAILURE, error});
      }
    );
  };
}

export function showPaymentMethodForm(noDialogBackground) {
  return function(dispatch, getState) {
    const paymentMethods = getState().paymentMethodsReducer.paymentMethods;
    dispatch({
      type: SHOW_PAYMENT_METHOD_FORM,
      noDialogBackground: noDialogBackground && paymentMethods.length,
    });
  };
}

export function hidePaymentMethodForm() {
  return {
    type: HIDE_PAYMENT_METHOD_FORM,
  };
}

export function createPaymentMethod({
  card_number,
  cardholder_name,
  cvv,
  expiry_month,
  expiry_year,
  postal_code,
  street_number,
  street_name,
}) {
  let formBody = {
    type: 'credit_card',
    details: {
      card_number,
      cardholder_name,
      cvv,
      expiry_date: `${expiry_year}-${expiry_month}-01`,
    },
  };
  if (shouldValidatePostalCode) {
    formBody = {...formBody, details: {...formBody.details, postal_code}};
  }
  if (shouldValidateAddress) {
    formBody = {
      ...formBody,
      details: {...formBody.details, street_number, street_name},
    };
  }
  return function(dispatch) {
    if (expiry_month > 12) {
      return dispatch(
        createAlert({type: 'error', message: 'Invalid Expiry Date'})
      );
    }
    if (expiry_year.length < 4) {
      return dispatch(
        createAlert({type: 'error', message: 'Invalid Expiry Year'})
      );
    }
    if (!isValidCreditCard(expiry_month, expiry_year)) {
      return dispatch(
        createAlert({type: 'error', message: 'Expired Credit Card'})
      );
    }

    dispatch({type: CREATE_PAYMENT_METHOD_REQUEST});
    return api.post(`/payment-methods`, formBody).then(
      response => {
        dispatch({
          type: CREATE_PAYMENT_METHOD_SUCCESS,
          response: response.data,
        });

        dispatch(getPaymentMethods());
      },
      error => {
        dispatch({type: CREATE_PAYMENT_METHOD_FAILURE, error});
      }
    );
  };
}

export function setDefaultPaymentMethod(cardId) {
  return function(dispatch) {
    dispatch({type: SET_DEFAULT_PAYMENT_METHOD_REQUEST});
    return api.post(`/payment-methods/${cardId}/default`).then(
      response => {
        dispatch({
          type: SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
          cardId,
        });
      },
      error => {
        dispatch({type: SET_DEFAULT_PAYMENT_METHOD_FAILURE, error});
      }
    );
  };
}

export function showConfirmDeletePaymentMethod() {
  return {
    type: SHOW_CONFIRM_DELETE_PAYMENT_METHOD,
  };
}

export function hideConfirmDeletePaymentMethod() {
  return {
    type: HIDE_CONFIRM_DELETE_PAYMENT_METHOD,
  };
}

export function deletePaymentMethod(cardId) {
  return function(dispatch) {
    dispatch({type: DELETE_PAYMENT_METHOD_REQUEST});
    return api.delete(`/payment-methods/${cardId}`).then(
      response => {
        dispatch(getPaymentMethods());
        dispatch({
          type: DELETE_PAYMENT_METHOD_SUCCESS,
          response: response.data,
        });
      },
      error => {
        dispatch({type: DELETE_PAYMENT_METHOD_FAILURE, error});
      }
    );
  };
}
